var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "", "mt-5": "" } },
    [
      _c("v-flex", { attrs: { xs6: "", md6: "" } }, [
        _c(
          "div",
          {
            staticClass: "attachment--drag-drop py-2 px-5",
            class: { active: _vm.dtDropZoneHovered },
            attrs: { id: "drop-area" },
            on: {
              drop: _vm.handleDropFiles,
              dragover: _vm.handleDrapOver,
              dragenter: _vm.handleDragEnter,
              dragleave: _vm.handleDragLeave
            }
          },
          [
            _c(
              "figure",
              {
                staticClass:
                  "text-lg-center text-md-center text-xs-center mt-4 mb-4"
              },
              [
                _c("img", { attrs: { src: _vm.coIcon } }),
                _vm._v(" "),
                _c("figcaption", { staticClass: "mt-1" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t(_vm.lblSetting.lblDragAndDrop)))
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm.dtFiles.length
              ? _c(
                  "v-container",
                  { staticClass: "files--wrapper", attrs: { "pt-0": "" } },
                  _vm._l(_vm.dtFiles, function(file, index) {
                    return _c(
                      "v-layout",
                      { key: index, attrs: { row: "", "mt-3": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", md2: "" } },
                          [
                            _c("v-img", {
                              staticStyle: {
                                height: "50px",
                                width: "50px",
                                "border-radius": "40px"
                              },
                              attrs: { src: file.file, alt: "icon" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            staticClass: "filename--container",
                            attrs: { xs12: "", md8: "" }
                          },
                          [
                            _vm.fkEditIndex !== index
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "mt-2 ml-2 filename--container__text"
                                  },
                                  [_vm._v(_vm._s(file.name))]
                                )
                              : _c("v-text-field", {
                                  staticClass: "pb-0 pt-0 mb-0 mt-0 ml-2",
                                  staticStyle: { width: "100%" },
                                  attrs: { maxlength: 100, clearable: "" },
                                  model: {
                                    value: _vm.fkEditModel,
                                    callback: function($$v) {
                                      _vm.fkEditModel = $$v
                                    },
                                    expression: "fkEditModel"
                                  }
                                })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", md1: "" } },
                          [
                            _vm.fkEditIndex !== index
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-0 pt-0",
                                    attrs: { text: "", icon: "" },
                                    on: {
                                      click: function($event) {
                                        _vm.handleEditAttachment(index)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "greyDarker" } },
                                      [_vm._v("edit")]
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-0 pt-0",
                                    attrs: { text: "", icon: "" },
                                    on: { click: _vm.handleUpdateAttachment }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "greyDarker" } },
                                      [_vm._v("done")]
                                    )
                                  ],
                                  1
                                )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.fkEditIndex !== index
                          ? _c(
                              "v-flex",
                              { attrs: { xs12: "", md1: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-0 pt-0",
                                    attrs: { text: "", icon: "" },
                                    on: {
                                      click: function($event) {
                                        _vm.handleDeleteAttachment(index)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "greyDarker" } },
                                      [_vm._v("delete")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dtFiles.length > 0
              ? _c(
                  "v-layout",
                  { attrs: { row: "", "justify-center": "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        staticStyle: { color: "#2E038C", "font-weight": "600" },
                        attrs: { round: "", color: "turquoise" },
                        on: { click: _vm.handleUpload }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.uploadButtonText) +
                            "\n                    "
                        ),
                        _c("v-icon", { attrs: { right: "", dark: "" } }, [
                          _vm._v("cloud_upload")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3631177b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3631177b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/attachment-drag-drop/template.html
// module id = null
// module chunks = 